import { useState, useEffect } from "react";
import { Empty } from "antd";
import ConteudoHistoricoDeCobranca from "./ConteudoHistoricoDeCobranca";
import { Content } from "./styles";
import ModalNovaCobranca from "components/ModalHistoricoCobranca/ModalHistoricoCobranca";
import useHistoricoCobranca from "features/cobranca/hooks/useHistoricoCobranca";
import { Skeleton } from "antd";
import CardDefault from "components/Cards/CardDefault";
import { Flex, Text } from "@chakra-ui/react";
import AddRemoveLineButton from "ui/components/Button/AddRemoveLineButton";
import ModalAnotacoesHistoricoCobranca from "./ModalAnotacoes";

interface HistoricoDeCobrancaProps {
  tenantId: string;
  unidadeId: string;
  pessoaId: string;
}

function HistoricoDeCobranca({
  tenantId,
  unidadeId,
  pessoaId,
}: HistoricoDeCobrancaProps) {
  const { data, isLoading, refetch } = useHistoricoCobranca(unidadeId);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [historicoEditId, setHistoricoEditId] = useState<string | undefined>();

  const [historicoAnotacoesId, setHistoricoAnotacoesId] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (historicoEditId) {
      setIsOpenModal(true);
    }
  }, [historicoEditId]);

  useEffect(() => {
    if (!isOpenModal) {
      setHistoricoEditId(undefined);
    }
  }, [isOpenModal]);

  return (
    <CardDefault>
      <Content>
        {isOpenModal ? (
          <ModalNovaCobranca
            tenantId={tenantId}
            unidadeId={unidadeId}
            pessoaId={pessoaId}
            historicoId={historicoEditId}
            isOpen={isOpenModal}
            onClose={() => setIsOpenModal(false)}
            onSaved={() => {
              setIsOpenModal(false);
              refetch();
            }}
          />
        ) : null}

        {historicoAnotacoesId ? (
          <ModalAnotacoesHistoricoCobranca
            isOpen={!!historicoAnotacoesId}
            onClose={() => setHistoricoAnotacoesId(undefined)}
            historicoId={historicoAnotacoesId}
          />
        ) : null}

        {isLoading || !data ? (
          <Skeleton active />
        ) : (
          <>
            <Flex gridGap={3} alignItems="center" mb={3}>
              <Text as="h3" fontSize={20} fontWeight="bold">
                Histórico de cobrança
              </Text>

              <AddRemoveLineButton
                onAdd={() => setIsOpenModal(true)}
                showRemove={false}
                size={6}
                containerProps={{ pt: 0 }}
              />
            </Flex>

            {data?.length ? (
              data?.map((item) => (
                <ConteudoHistoricoDeCobranca
                  data={item}
                  onOpenAnotacoes={() => setHistoricoAnotacoesId(item.id)}
                  onEdit={() => setHistoricoEditId(item.id)}
                />
              ))
            ) : (
              <Empty
                style={{ marginTop: 58 }}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            )}
          </>
        )}
      </Content>
    </CardDefault>
  );
}

export default HistoricoDeCobranca;
